module.exports = __webpack_public_path__ + "img/stijlen-bohemian.65666587.png";